import { http } from '@/utils/http'

/** 按桌台查看订单菜品信息 */
export const orderSkuListByTable = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showOrderSku_table', data)
}

/** 按菜品查看订单菜品信息 */
export const orderSkuListByDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showOrderSku_dishes', data)
}
/** 查看历史订单菜品信息 */
export const orderSkuListByHistory = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/showHistoryKDSInfo', data)
}
//获取档口配置
export function getDeviceList(data: any) {
  return http({
    url: '/shop/printer/list',
    method: 'GET',
    query: data,
  })
}

/** 设置配菜状态 */
export const configDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/configDishes', data)
}

/** 设置出菜状态 */
export const outDishes = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/outDishes', data)
}

/** 设置挂起状态 */
export const setHandUp = (data: any) => {
  return http.post<any>('/orderSkuKDSApi/setHandUpFlag', data)
}
/** 获取tts语音 */
export const getTts = (data: any) => {
  return http.get<any>('/shop/tts/voice', data)
}
